import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../../constants/endpoints';
import { SpecField } from '../../../interfaces/spec-layout';
import { VitalSignAttribute, VitalSignDTO, VitalSignValidatorResponse } from '../../../interfaces/vital-sign';
import BaseController from '../../BaseController';

class VitalSignService  {

  ownerController: BaseController;

  constructor ( ownerController: BaseController ) {

    this.ownerController = ownerController;

  }

  release( encounterId: number, vitalSignalId: number ): Promise<boolean> {

    const released: Promise<boolean> = HttpService.put(

      Endpoint.VITAL_SIGN_RELEASE,
      { encounterId, vitalSignalId }

    ).then( response => {

      const { body } = response;

      return body === true;

    }).catch(( err )  => {

      throw err

    });

    return released;

  }

  public static delete( encounterId: number, vitalSignId: number ): Promise<boolean> {

    const deleted: Promise<boolean> = HttpService.delete(

      Endpoint.VITAL_SIGN_DELETE,
      { encounterId, vitalSignId }

    ).then(( response ) => {

      const { body } = response;

      return body === true;

    }).catch(( err ) => {

      throw err;

    });

    return deleted;

  }

  inactivate( encounterId: number, vitalSignId: number, dsJustificativa: string ): Promise<boolean> {

    const inactivated: Promise<boolean> = HttpService.put(

      Endpoint.VITAL_SIGN_INACTIVATE,
      {
        dsJustificativa,
        encounterId,
        vitalSignId,
      }

    ).then(( response ) => {

      const { body } = response;

      return body === true;

    }).catch(( err ) => {

      throw err;

    });

    return inactivated;

  }

  public static validateVitalSign( encounterId: number, attributeId: number, patientId: number, vitalSignValue: number | null ): Promise<VitalSignValidatorResponse> {
    return HttpService.get(Endpoint.VITAL_SIGN_VALIDATE, {
      attributeId,
      encounterId,
      patientId,
      vitalSignValue,
    }).then( response => {
      return response?.body as VitalSignValidatorResponse;
    });
  }

  async getVitalSignDTO( encounterId: number, vitalSignId: number ): Promise<VitalSignDTO | undefined> {

    let vitalSignDTO: Promise<VitalSignDTO> | undefined;

    if ( encounterId && vitalSignId ) {

      vitalSignDTO = HttpService.get(

        Endpoint.GET_VITAL_SIGN,
        { encounterId, vitalSignId }

      ).then( response => {

        return response?.body as VitalSignDTO;

      }).catch(( err ) => {

        throw err;

      });

    }

    return vitalSignDTO;

  }

  parseType( dataBaseColumnType: string ): string {

    let type = '';

    switch ( dataBaseColumnType.toUpperCase() ) {

      case 'VARCHAR':
      case 'VARCHAR2':
      case 'CHAR': type = 'string';
        break;

      case 'LONG': type = 'text';
        break;

      case 'DATE': type = 'timestamp';
        break;

      case 'NUMBER': type = 'number';
        break;

      default: type = 'string';
        break;

    }

    return type;

  }

  isAttributeRequired( attribute: VitalSignAttribute ): boolean {

    return attribute?.required ? attribute.required.toUpperCase() === 'S' : false;

  }

  createSpecField( attribute: VitalSignAttribute ): SpecField | undefined {

    if ( !attribute ) return undefined;

    const required = this.isAttributeRequired( attribute );

    let dsType = 'string';
    let listDomain;
    let attributeValue;
    let value = attribute.value ? attribute.value : attribute.dsValue;

    if ( attribute.value === 0 ) {
      value = 0;
    }

    switch ( attribute.ieComponent.toLowerCase() ) {

      case 'de':
        dsType = this.parseType(attribute.dsType);
        attributeValue = value;
        break;

      case 'lcb':
        dsType = 'lookup';
        listDomain = attribute.vitalSignDomains;
        attributeValue = attribute.vitalSignDomains.find(({ cd }) => cd === value );
        break;

      default:
        break;

    }

    const specField: SpecField = {
      decimals: attribute.decimals,
      id: attribute.nrAttribute,
      idAttributeValidate: attribute.nrAttributeValidate,
      label: attribute.dsLabel ? attribute.dsLabel : undefined,
      length: attribute.length,
      list: listDomain,
      name: attribute.nmAttribute,
      readOnly: false,
      required: required,
      type: dsType,
      value: attributeValue,
    }

    return specField;

  }

  isSpecialAttribute( attribute: VitalSignAttribute ): boolean {

    switch ( attribute.nmAttribute.toUpperCase() ) {

      case 'DT_SINAL_VITAL':
      case 'IE_UNID_MED_PESO':
      case 'IE_UNID_MED_ALTURA': return true
      default: return false;

    }

  }

  isWeigthAttribute( attribute: VitalSignAttribute ): boolean {

    switch ( attribute.nmAttribute.toUpperCase() ) {

      case 'QT_PESO_ATUAL':
      case 'QT_PESO': return true;
      default: return false;

    }

  }

  isHeigthAttribute( attribute: VitalSignAttribute ): boolean {

    switch ( attribute.nmAttribute.toUpperCase() ) {

      case 'QT_ALTURA_CM':
      case 'QT_ALTURA_M': return true;
      default: return false;

    }

  }

}

export default VitalSignService;

